import { Icon } from '@components/atoms/Icon';
import { IconType } from '@src/types/IconType';

export const BadgeIndicator = () => {
  return (
    <Icon
      type={IconType.PositionIndicator}
      className="absolute -top-3.5 left-1/2 -translate-x-1/2 text-grey1 w-3 h-3"
    />
  );
};
